import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
/*
 * Шрифти зі своєї статики, а не з Google.
 *
 * Беремо ЛИШЕ `wght.css` (прямі накреслення) — курсив у макеті не
 * використовується, а це вдвічі менше файлів. Змінні шрифти дають увесь
 * діапазон насиченості одним файлом на підмножину, тож дев'ять окремих
 * ваг зі старого посилання на Google перетворюються на чотири файли.
 *
 * Імена сімейств («Nunito Variable») навмисно збігаються з тими, що вже
 * стоять у `tokens.css`: там вони були прописані з самого початку, просто
 * жодного файлу під них не існувало.
 */
import '@fontsource-variable/nunito/wght.css';
import '@fontsource-variable/rubik/wght.css';
import '@fontsource-variable/unbounded/wght.css';

// app.css сам підтягує styles/tokens.css одразу після Tailwind —
// тільки за такого порядку Tailwind v4 бачить @theme з токенів.
import './styles/app.css';

import { createDexiePersister, createQueryClient } from './lib/queryClient';
import { buildRouter } from './router';

const queryClient = createQueryClient();
const persister = createDexiePersister();
const router = buildRouter(queryClient);

const container = document.getElementById('root');
if (!container) throw new Error('Немає #root — index.html зламано');

createRoot(container).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 7 * 24 * 3600_000,
        buster: 'v1',
        dehydrateOptions: {
          // У кеш кладемо лише успішні запити: помилки після F5 не потрібні.
          shouldDehydrateQuery: (query) => query.state.status === 'success',
        },
      }}
    >
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </StrictMode>,
);
